import React from 'react';
import { Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Checkbox } from '@/components/ui/checkbox';
import { CHECKLIST_ITEMS } from './constants';

export const ChecklistDescription = ({
  woId, workOrder, isAtelier, checklist, setChecklist, description, setDescription,
  sinistreNumbers, onSaveSinistreNumber, onSaveChecklist, saving,
}) => {
  const toggleChecklist = (key) => {
    setChecklist(prev => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <>
      <Card className="p-4 rounded-xl space-y-4" data-testid="workorder-checklist">
        <h3 className="text-sm font-bold text-slate-900">Demandes du client</h3>
        <div className="grid md:grid-cols-3 gap-6">
          {Object.entries(CHECKLIST_ITEMS).map(([cat, items]) => (
            <div key={cat} className="space-y-2">
              <p className="text-xs font-bold text-slate-500 uppercase tracking-wider">{cat}</p>
              {items.map(item => (
                <div key={item.key} className="flex items-center gap-2 cursor-pointer text-sm" data-testid={`checklist-${item.key}`}
                  onClick={(e) => { e.preventDefault(); if (!isAtelier && workOrder.status !== 'signed' && workOrder.status !== 'completed') toggleChecklist(item.key); }}>
                  <Checkbox
                    checked={!!checklist[item.key]}
                    disabled={isAtelier || workOrder.status === 'signed' || workOrder.status === 'completed'}
                  />
                  <span>{item.label}</span>
                </div>
              ))}
              {cat === 'assurance' && (
                <div className="mt-3 space-y-1.5">
                  <Label className="text-xs text-slate-500">N° de sinistre</Label>
                  {[0, 1, 2].map(idx => (
                    <Input key={idx} value={sinistreNumbers[idx] || ''} onChange={(e) => onSaveSinistreNumber(idx, e.target.value)}
                      placeholder={`Sinistre ${idx + 1}...`} className="h-8 text-sm"
                      disabled={isAtelier || workOrder.status === 'signed' || workOrder.status === 'completed'}
                      data-testid={`sinistre-number-${idx}`} />
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </Card>

      <Card className="p-4 rounded-xl space-y-3">
        <Label className="text-sm font-bold">Description / Demande client</Label>
        <Textarea value={description} onChange={(e) => setDescription(e.target.value)} rows={3}
          disabled={isAtelier || workOrder.status === 'signed' || workOrder.status === 'completed'} data-testid="workorder-description" />
        {!isAtelier && workOrder.status !== 'signed' && workOrder.status !== 'completed' && (
          <Button onClick={onSaveChecklist} disabled={saving} data-testid="save-workorder-btn">
            <Check className="mr-1 w-4 h-4" /> {saving ? 'Enregistrement...' : 'Enregistrer la fiche'}
          </Button>
        )}
      </Card>
    </>
  );
};
